import React from 'react';
import classnames from 'classnames';
import { Icon, iconArrowLeft } from '@jimdo/ui';
import './backButton.scss';

interface Props {
  label: string;
  className?: string;
  onClick: () => void;
}

const BackButton: React.FC<Props> = (props: Props) => {
  const { label, className, onClick } = props;
  return (
    <button
      className={classnames('back-button-component', className)}
      onClick={onClick}
    >
      <Icon className="back-button-component__icon" icon={iconArrowLeft} />
      <span className="back-button-component__title">{label}</span>
    </button>
  );
};

export default BackButton;
